const headerData = [
  {
    prop: "id",
    label: "序号",
    columnwidth: 50,
  },
  {
    prop: "Title",
    label: "文件名",
    columnwidth: 435,
  },
  {
    prop: "FileType",
    label: "文件类型",
    columnwidth: 150,
  },
  {
    prop: "Code",
    label: "单据号",
    columnwidth: 150,
  },
  {
    prop: "CreateTime",
    label: "日期",
    columnwidth: 200,
  },
  {
    prop: "Attachment",
    label: "操作",
    columnwidth: 170,
    // fixed: "right",
  },
];
export default headerData;
